import { css } from 'aphrodite';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { IOperationResultNoValue } from '../../../../extViewmodels';
import { MastheadPortalId } from '../../../../models/AdminModels';
import { useAdminUserSession } from '../../../../models/hooks/adminStateHooks';
import { useErrorMessages } from '../../../../models/hooks/appStateHooks';
import { AdminReportingViewModel } from '../../../../viewmodels/AdminViewModels';
import { Breadcrumb, BreadcrumbItem, BreadcrumbList, BreadcrumbPage } from '../../../../web/components/Breadcrumb';
import { Portal } from '../../../../web/components/Portal';
import { BenjaminsSection } from '../../../components/reporting/BenjaminsSection';
import { BookOfBusinessSection } from '../../../components/reporting/BookOfBusinessSection';
import { DailyActiveUseSection } from '../../../components/reporting/DailyActiveUseSection';
import { NextMonthSection } from '../../../components/reporting/NextMonthSection';
import { styleSheet } from './styles';

function _ReportsContainer() {
	const adminUserSession = useAdminUserSession();
	const errorMessages = useErrorMessages();
	const [reportsVM] = useState(() => new AdminReportingViewModel(adminUserSession));
	useEffect(() => {
		reportsVM.loadAll()?.catch((err: IOperationResultNoValue) => {
			errorMessages.pushApiError(err);
		});
	}, [reportsVM, errorMessages]);

	return (
		<div className={css(styleSheet.container)}>
			<Portal destination={MastheadPortalId}>
				<Breadcrumb>
					<BreadcrumbList>
						<BreadcrumbItem>
							<BreadcrumbPage>Reports</BreadcrumbPage>
						</BreadcrumbItem>
					</BreadcrumbList>
				</Breadcrumb>
			</Portal>
			<div className={css(styleSheet.upperSection)}>
				<DailyActiveUseSection reportsVM={reportsVM} />
			</div>
			<div className={css(styleSheet.lowerSection)}>
				<div className={css(styleSheet.left)}>
					<BenjaminsSection />

					<NextMonthSection reportsVM={reportsVM} />
				</div>
				<div className={css(styleSheet.right)}>
					<BookOfBusinessSection />
				</div>
			</div>
		</div>
	);
}

export const ReportsContainer = observer(_ReportsContainer);
